import React from "react"
export function PlusFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm.75 3.757h-1.5V9.25H5.757v1.5H9.25v3.493h1.5V10.75h3.493v-1.5H10.75V5.757z"
        fill="currentColor"
        id="prefix__plus---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
